import React from "react";
import ReactDOM from "react-dom";

interface ModalWrapperProps {
  children: React.ReactNode;
  open?: boolean;
  setOpen?: (open: boolean) => void;
  width?: string;
}

const ModalWrapper: React.FC<ModalWrapperProps> = ({
  children,
  open = true,
  setOpen,
  width,
}) => {
  if (!open) return null;

  const modalRoot = document.getElementById("modal-root");

  const content = (
    <div
      className="modal-wrapper-inner"
      style={width ? { width, maxWidth: "100%" } : {}}
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </div>
  );

  if (!modalRoot) {
    return <div className="modal-wrapper-fallback">{content}</div>;
  }

  return ReactDOM.createPortal(content, modalRoot);
};

export default ModalWrapper;
